import React from "react";
import { Label, Checkbox } from "@/components/ui";
import { CheckCircle } from "lucide-react";

/**
 * Posting Status Filter Component
 *
 * Checkbox filter for transaction posting status.
 * Requirements: 5.1-5.9
 */
const PostingStatusFilter = ({ selectedStatuses = [], onChange }) => {
  const statuses = [
    { value: "draft", label: "Draft" },
    { value: "posted", label: "Posted" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const handleToggle = (statusValue) => {
    const newSelection = selectedStatuses.includes(statusValue)
      ? selectedStatuses.filter((s) => s !== statusValue)
      : [...selectedStatuses, statusValue];
    onChange(newSelection);
  };

  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2">
        <CheckCircle className="h-4 w-4" />
        Posting Status
      </Label>
      <div className="space-y-2">
        {statuses.map((status) => (
          <div key={status.value} className="flex items-center space-x-2">
            <Checkbox
              id={`status-${status.value}`}
              checked={selectedStatuses.includes(status.value)}
              onCheckedChange={() => handleToggle(status.value)}
            />
            <label
              htmlFor={`status-${status.value}`}
              className="text-sm cursor-pointer"
            >
              {status.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostingStatusFilter;
